export default [
  {
    czWord: "	minus pět stupňů 	",
    wordTranslated: "	minus five degrees, five degrees below zero	",
  },
  { czWord: "	velká písmena	", wordTranslated: "	capital letters	" },
  { czWord: "	trest smrti	", wordTranslated: "	capital punishment, death penalty	" },
  { czWord: "	graf, schéma	", wordTranslated: "	chart	" },
  { czWord: "	Jak daleko je to odtud?	", wordTranslated: "	How far is it from here?	" },
  {
    czWord: "	Válka skončila, spory však pokračují.	",
    wordTranslated: "	The war is over, however the disputes go on	",
  },
  { czWord: "	široko daleko	", wordTranslated: "	near and far	" },
  { czWord: "	na protější straně	", wordTranslated: "	on the opposite side	" },
  { czWord: "	zkušební lhůta	", wordTranslated: "	probationary period	" },
  { czWord: "	záruční lhůta/doba	", wordTranslated: "	warranty period	" },
  { czWord: "	zkušební doba před přijetím do práce	", wordTranslated: "	probation (period)	" },
  { czWord: "	přesně jedna libra	", wordTranslated: "	an even pound	" },
  { czWord: "	v praxi, ve skutečnosti, fakticky	", wordTranslated: "	in practice	" },
  { czWord: "	být ze cviku	", wordTranslated: "	be out of practice	" },
  { czWord: "	provádět rituály	", wordTranslated: "	practise rituals	" },
  { czWord: "	Voda je pěkně studená.	", wordTranslated: "	The water is pretty cold	" },
  { czWord: "	celkem jednoduše	", wordTranslated: "	quite simply	" },
  { czWord: "	Celkem se mi to líbilo.	", wordTranslated: "	I quite liked it.	" },
  { czWord: "	příšerný nepořádek	", wordTranslated: "	terrible mess	" },
  { czWord: "	Hrozně jsi mě vylekal.	", wordTranslated: "	You gave me a terrible fright.	" },
  { czWord: "	strašná nehoda	", wordTranslated: "	terrible accident	" },
  { czWord: "	kapsy od kalhot	", wordTranslated: "	trouser pockets	" },
  {
    czWord: "	podle plánu	",
    wordTranslated: "	according to the plan, as planned,  as scheduled	",
  },
  { czWord: "	podle propočtů	", wordTranslated: "	according to calculations	" },
  { czWord: "	oblasti postižené záplavami	", wordTranslated: "	areas affected by floods	" },
  { czWord: "	i když	", wordTranslated: "	even when, even though, although	" },
  { czWord: "	Připadne mi to nespravedlivé.	", wordTranslated: "	It appears unfair to me.	" },
  { czWord: "	mladistvý vzhled	", wordTranslated: "	youthful appearance	" },
  { czWord: "	Nepři se se mnou!	", wordTranslated: "Don't argue with me!" },
  { czWord: "	domluvit (si) schůzku	", wordTranslated: "	arrange a meeting	" },
  { czWord: "	Zařídím to.	", wordTranslated: "	I will arrange it.	" },
  { czWord: "	dohodnout se, že...	", wordTranslated: "	make an arrangement that	" },
  { czWord: "	tvrdě spát, zařezávat	", wordTranslated: "	be fast asleep	" },
  { czWord: "	Spíš?	", wordTranslated: "	Are you asleep?	" },
  { czWord: "	Účastnil se setkání.	", wordTranslated: "	He attended the meeting.	" },
  { czWord: "	vařená rýže	", wordTranslated: "	boiled rice	" },
  { czWord: "	bod varu	", wordTranslated: "	boiling point	" },
  { czWord: "	čistý list papíru	", wordTranslated: "	blank sheet of paper	" },
  { czWord: "	čistý formulář nepopsaný	", wordTranslated: "	blank form	" },
  { czWord: "	stinná/světlá stránka čeho	", wordTranslated: "	the darker/bright side	" },
  { czWord: "	oděvní průmysl	", wordTranslated: "	clothing industry	" },
  { czWord: "	několik vrstev oblečení	", wordTranslated: "	several layers of clothing	" },
  { czWord: "	sloupec tabulky	", wordTranslated: "	table column	" },
  { czWord: "	v prostředním sloupci	", wordTranslated: "	n the middle column	" },
  { czWord: "	Soutěží mezi sebou.	", wordTranslated: "	They compete with each other.	" },
  {
    czWord: "	konkurenční boj	",
    wordTranslated: "	competition, competing, competitive struggle	",
  },
  { czWord: "	tvůrčí psaní	", wordTranslated: "	creative writing	" },
  { czWord: "	houfy spousty	", wordTranslated: "	hordes, crowds, army	" },
  { czWord: "	diváci, publikum	", wordTranslated: "	the crowd	" },
  { czWord: "	přelidněný, přeplněný	", wordTranslated: "	crowded	" },
  { czWord: "	kudrnatý osoba	", wordTranslated: "	curly-haired	" },
  { czWord: "	cyklistická stezka	", wordTranslated: "	cycle track	" },
  { czWord: "	Objevil novou planetu.	", wordTranslated: "	He discovered a new planet.	" },
  { czWord: "	buď ... anebo	", wordTranslated: "	either ... or	" },
  { czWord: "	tak či tak/onak	", wordTranslated: "	either way	" },
  { czWord: "	obrovský, ohromný,	", wordTranslated: "	enormous	" },
  { czWord: "	přesný opak	", wordTranslated: "	the exact opposite	" },
  { czWord: "	právě v tento okamžik	", wordTranslated: "	this exact moment	" },
  { czWord: "	až na to, že,	", wordTranslated: "	except that	" },
  { czWord: "	vyjádřit svůj zármutek	", wordTranslated: "express one's sorrow" },
  { czWord: "	vyjádřit hluboké politování	", wordTranslated: "express one's deep regret" },
  { czWord: "	bezpečnostní prvky	", wordTranslated: "	safety features	" },
  { czWord: "	(vý)počty	", wordTranslated: "	figures	" },
  { czWord: "	řečnický obrat	", wordTranslated: "	figure of speech	" },
  { czWord: "	jíst příborem	", wordTranslated: "	use a knife and fork	" },
  { czWord: "	Naštěstí se vrátil včas.	", wordTranslated: "	Fortunately, he came back on time.	" },
  { czWord: "	pokročit,	", wordTranslated: "	go further	" },
  { czWord: "	bez (dalších) okolků/průtahů	", wordTranslated: "	without further/more ado	" },
  { czWord: "	zabránit dalším škodám	", wordTranslated: "	prevent further damage	" },
  { czWord: "	(mezi)generační propast	", wordTranslated: "	generation gap	" },
  { czWord: "	překlenout propast mezi	", wordTranslated: "	bridge the gap between	" },
  { czWord: "	cena bez/včetně DPH	", wordTranslated: "	price excluding/including VAT	" },
  { czWord: "	To je v ceně. zahrnuto	", wordTranslated: "It's included (in the price)" },
  { czWord: "	zaplést se, zapojit se	", wordTranslated: "	get involved in	" },
  {
    czWord: "	Stal se účastníkem dopravní nehody.	",
    wordTranslated: "	He was involved in a car accident.	",
  },
  { czWord: "	účastník nehody	", wordTranslated: "	person involved in the accident	" },
  { czWord: "	ani v nejmenším/trochu	", wordTranslated: "	not in the least	" },
  { czWord: "	v neposlední řadě	", wordTranslated: "	last (but) not least	" },
  { czWord: "	pravděpodobně	", wordTranslated: "	likely	" },
  { czWord: "	pozorný posluchač	", wordTranslated: "	attentive listener	" },
  { czWord: "	nákladní vůz	", wordTranslated: "	lorry, truck	" },
  { czWord: "	Je to nádherné město.	", wordTranslated: "it's a lovely city" },
  { czWord: "	Je krásně. o počasí	", wordTranslated: "	The weather is lovely.	" },
  { czWord: "	převážná část	", wordTranslated: "major part," },
  { czWord: "	mhouřit oči	", wordTranslated: "narrow one's eyes, squint, squinch" },
  { czWord: "	úzký, těsný	", wordTranslated: "	narrow	" },
  { czWord: "	ani zdaleka (ne)	", wordTranslated: "	not nearly	" },
  { czWord: "	ořech, oříšek , matice, matka, blázen, fanatik	", wordTranslated: "	nut	" },
  { czWord: "	pec, trouba, kamna	", wordTranslated: "	oven	" },
  { czWord: "	zacházet do detailů	", wordTranslated: "	go into particulars	" },
  { czWord: "	Co konkrétně?	", wordTranslated: "	What in particular?	" },
  {
    czWord: "	Máš na mysli něco konkrétního?	",
    wordTranslated: "	Have you anything particular in mind?	",
  },
  { czWord: "	vzor	", wordTranslated: "	pattern	" },
  { czWord: "	(vy)konat, provést, (u)dělat	", wordTranslated: "	perform	" },
  { czWord: "	možná, třeba, snad nejistota	", wordTranslated: "	perhaps	" },
  { czWord: "	domácí mazlíček	", wordTranslated: "	pet	" },
  { czWord: "	rostlina	", wordTranslated: "	plant	" },
  { czWord: "	talíř, tác, podnos	", wordTranslated: "	plate	" },
  { czWord: "	kapsa	", wordTranslated: "	pocket	" },
  { czWord: "	znečištění atmosféry	", wordTranslated: "	atmospheric pollution	" },
  { czWord: "	znečištění ovzduší	", wordTranslated: "	air pollution	" },
  { czWord: "	Vykulil oči ...	", wordTranslated: "	His eyes popped	" },
  { czWord: "	Existuje spousta možností.	", wordTranslated: "	There are lots of possibilities	" },
  { czWord: "	vyčerpat všechny možnosti	", wordTranslated: "	exhaust all possibilities	" },
  { czWord: "	Předpovědět	", wordTranslated: "	Predict	" },
  { czWord: "	Lze tomu předcházet.	", wordTranslated: "	It may be prevented.	" },
  { czWord: "	zamezit šíření nemoci	", wordTranslated: "	prevent the spread of the disease	" },
  { czWord: "	přesný	", wordTranslated: "	precise	" },
  { czWord: "	přesněji řečeno	", wordTranslated: "	to be more precise	" },
  { czWord: "	poskytnout služby	", wordTranslated: "	provide services	" },
  { czWord: "	pro ilustraci, na ukázku	", wordTranslated: "	for illustrative purposes	" },
  { czWord: "	pro léčebné účely	", wordTranslated: "	for medicinal purposes	" },
  { czWord: "	zvýšit hlas při rozčilení ap.	", wordTranslated: "raise one's voice" },
  { czWord: "	Raději bych to nedělal.	", wordTranslated: "I'd rather not do that." },
  { czWord: "	Než tady čekat, půjdu sám.	", wordTranslated: "I'll go alone rather than wait." },
  { czWord: "	nedávné události	", wordTranslated: "	recent events	" },
  { czWord: "	Odkázal mě na Vás.	", wordTranslated: "	He referred me to you	" },
  { czWord: "	odkázat	", wordTranslated: "	refer	" },
  { czWord: "	pravidelně	", wordTranslated: "	on a regular basis	" },
  { czWord: "	v pravidelných intervalech	", wordTranslated: "	at regular intervals	" },
  { czWord: "	ozvat se na inzerát	", wordTranslated: "	respond to an advertisement	" },
  { czWord: "	v reakci na	", wordTranslated: "	in response	" },
  { czWord: "	posoudit situaci	", wordTranslated: "	review a situation	" },
  { czWord: "	zopakovat si slovíčka	", wordTranslated: "	review/revise vocabulary	" },
  { czWord: "	posouzení	", wordTranslated: "	review	" },
  { czWord: "	odpadky	", wordTranslated: "	rubbish	" },
  { czWord: "	kecat nesmysly	", wordTranslated: "	talk rubbish	" },
  { czWord: "	rozvrh, plán	", wordTranslated: "	schedule	" },
  { czWord: "	Čelí několika obviněním.	", wordTranslated: "	He faces several charges	" },
  { czWord: "	několikrát	", wordTranslated: "	several times	" },
  { czWord: "	nepřirozený tvar	", wordTranslated: "	unnatural shape	" },
  { czWord: "	být v dobré kondici	", wordTranslated: "	be in good shape	" },
  { czWord: "	prostěradlo	", wordTranslated: "	sheet	" },
  { czWord: "	místo,plocha	", wordTranslated: "	site	" },
  { czWord: "	vyřešit	", wordTranslated: "	solve	" },
  { czWord: "	objasnit vraždu	", wordTranslated: "	solve the murder (case)	" },
  {
    czWord: "	Právě to řešíme.	",
    wordTranslated: "	We are just trying to solve/looking into it	",
  },
  { czWord: "	třídit	", wordTranslated: "	sort	" },
  { czWord: "	razítko	", wordTranslated: "	stamp	" },
  { czWord: "	stav/stát	", wordTranslated: "	state	" },
  { czWord: "	válečný stav	", wordTranslated: "	state of war	" },
  {
    czWord: "	průzkum (veřejného) mínění, zjišťování názorů	",
    wordTranslated: "	(public) opinion survey	",
  },
  { czWord: "	průzkum	", wordTranslated: "	survey	" },
  { czWord: "	dráha	", wordTranslated: "	track	" },

  
];
